/* Carry only campaign identifiers, never arbitrary query strings or customer data. */
(() => {
  'use strict';
  const keys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id','tblci'];
  const storageKey = 'reviva-campaign';
  let values = {};
  try {values = JSON.parse(sessionStorage.getItem(storageKey) || '{}') || {};} catch (_) {}
  const current = new URLSearchParams(location.search);
  // An explicit new campaign replaces stale first-party campaign parameters.
  if (keys.some(k => current.has(k))) values = {};
  const campaign = {};
  keys.forEach(k => {
    const value = current.get(k) || values[k];
    if (typeof value === 'string' && value.length <= 2048) campaign[k] = value;
  });
  try {sessionStorage.setItem(storageKey, JSON.stringify(campaign));} catch (_) {}
  function url(path) {
    const target = new URL(path, location.origin);
    if (target.origin !== location.origin) return path;
    Object.entries(campaign).forEach(([k,v]) => target.searchParams.set(k,v));
    return target.pathname + target.search + target.hash;
  }
  window.RevivaAttribution = {url, values:campaign};
  document.querySelectorAll('a[href]').forEach(a => {
    const target = new URL(a.href, location.origin);
    if (target.origin === location.origin && /\/(pages\/reviva-sales|cart|checkout)$/.test(target.pathname)) a.href=url(a.href);
  });
  let submitting = false;
  const offerButtons = [...document.querySelectorAll('[data-reviva-offer] button[type="submit"]')];
  const enabled = offerButtons.filter(button => !button.disabled);
  window.addEventListener('pageshow', () => {submitting=false; enabled.forEach(button=>{button.disabled=false;});});
  document.querySelectorAll('[data-reviva-offer]').forEach(form => {
    form.addEventListener('submit', event => {
      if (submitting) {event.preventDefault(); return;}
      submitting=true; enabled.forEach(button=>{button.disabled=true;});
    });
    Object.entries(campaign).forEach(([name,value]) => {
      const input=document.createElement('input'); input.type='hidden'; input.name=name; input.value=value; form.append(input);
    });
  });
})();
